import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import { getSnowplowUserData } from '@/utils/analytics/analytics-utils';
import { BFF_UAT_URL, REQUEST_HEADERS } from 'Api/constants';
import { getAccessToken, getSiteId, isLoggedIn } from 'Utils/auth';

export const baseURL = () => {
  if (!process.env.NEXT_PUBLIC_BFF_URL) {
    return BFF_UAT_URL;
  }
  return `${process.env.NEXT_PUBLIC_BFF_URL}/${getSiteId()}`;
};

const authHeader = isLoggedIn()
  ? { [REQUEST_HEADERS.AUTHORIZATION]: isLoggedIn() }
  : { [REQUEST_HEADERS.ACCESS_TOKEN]: getAccessToken() };

const client = axios.create({
  baseURL: baseURL(),
  headers: {
    ...authHeader,
    [REQUEST_HEADERS.SNOWPLOW_USER_ID]: getSnowplowUserData().domainUserId,
    [REQUEST_HEADERS.X_APIKEY]: process.env.NEXT_PUBLIC_BFF_API_KEY,
  },
});

client.interceptors.request.use(
  (config) => {
    config.headers[REQUEST_HEADERS.REQUEST_ID] = uuidv4();
    if (['post', 'patch', 'put'].includes(config.method)) {
      config.headers[REQUEST_HEADERS.CONTENT_TYPE] = REQUEST_HEADERS.APPLICATION_JSON;
    }
    return config;
  },
  null,
  { synchronous: true }
);

export default client;
